import { Inject, Pipe, PipeTransform } from '@angular/core';
import { APP_CONFIG } from '../../configurations/configurations.factory';
import { Configurations } from '../../configurations/models/configurations.model';

@Pipe({
    name: 'booleanRawvalue',
    standalone: false
})
export class BooleanRawvaluePipe implements PipeTransform {

  constructor(@Inject(APP_CONFIG) private readonly config: Configurations) { }

  transform(value: string | undefined | null): boolean {
    return this.config.booleanRawvaluesMappingConfig.forTrueValues.some(v => v.toLowerCase() == value?.toLowerCase())
  }

}
